/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import RoleToggle from "../../components/RoleToggle";
import { useEffect, useState } from "react";
import {
  IconChevronLeft,
  IconCloudDown,
  IconDownload,
  IconEdit,
  IconEye,
} from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import ListView from "../../components/common/ListView";
import ToggleButton from "../../components/ToggleButton";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import {
  useFetchOutSourcesDataDetails,
  useUpdateOutSourceData,
} from "../../apis/outSourceApis";
import formatDate from "../../utilities/helper";
import AddOutSourceModal from "./_components/AddOutSourceModal";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import NewCommonModal from "../../components/common/NewCommonModal";
import { usePermission } from "../../hooks/usePermissionTabs";
import { useCustomerDetails } from "../../apis/merchantApis";

const outSourceData = [
  {
    id: 1,
    img: "/img/dummy-img.png",
    name: "Jhon",
    driverCode: "#97846",
    driverId: "#789010",
    routeCode: "RUH-001",
    contact: "787965412",
    emailAddress: "Example@gmail.com",
    date: "20, Street Riyadh",
    assignStatus: "Assigned",
    active: false,
  },
  {
    id: 2,
    img: "/img/dummy-img.png",
    name: "Jhon",
    driverCode: "#97846",
    driverId: "#789010",
    routeCode: "RUH-001",
    contact: "787965412",
    emailAddress: "Example@gmail.com",
    date: "20, Street Riyadh",
    assignStatus: "Not Assign",
    active: true,
  },
  {
    id: 3,
    img: "/img/dummy-img.png",
    name: "Jhon",
    driverCode: "#97846",
    driverId: "#789010",
    routeCode: "RUH-001",
    contact: "787965412",
    emailAddress: "Example@gmail.com",
    date: "20, Street Riyadh",
    assignStatus: "Assigned",
    active: false,
  },
  {
    id: 4,
    img: "/img/dummy-img.png",
    name: "Jhon",
    driverCode: "#97846",
    driverId: "#789010",
    routeCode: "RUH-001",
    contact: "787965412",
    emailAddress: "Example@gmail.com",
    date: "20, Street Riyadh",
    assignStatus: "Not Assign",
    active: true,
  },
];
type FormValues = {
  companyName: string;
  mobileNo: string;
  email: string;
  address: string;
  vatNumber: string;
  vatDoc: File;
  crNumber: string;
  crDoc: File;
  serviceAreaCoverage: string;
  contractStartDate: Date;
  contractEndDate?: Date;
  billingCycle: string;
  contractDoc: File;
  primaryContactName: string;
  primaryContactNumber: string;
  primaryEmailAddress: string;
  warehouseId: string;
  cityId?: string;
  specialization?: string;
  companyLogo: File;
  contactPersonName: string;
};

interface DocumentLinkProps {
  value?: string;
  docUrl?: string;
  label: string;
}

const DocumentLink = ({ value, docUrl, label }: DocumentLinkProps) => {
  if (!value && !docUrl) return null;

  return (
    <div className="flex items-center gap-2">
      {value && <span className="font-medium text-gray-800">{value}</span>}
      {docUrl && (
        <a
          href={docUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded"
          title={`View ${label} Document`}
          aria-label={`View ${label} Document`}
        >
          <IconCloudDown strokeWidth={1.5} size={22} />
        </a>
      )}
    </div>
  );
};

export default function ViewCustomerDetails() {
  // const route = useParams();
  const { id } = useParams();
  const { data, isFetching, refetch } = useCustomerDetails(id);
  // const { id } = route;
  const { mutate, isPending } = useUpdateOutSourceData(id);
  // const { data, refetch } = useFetchOutSourcesDataDetails(id);
  const [credential, setCredential] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] = useState<any>({
    vatDoc: false,
    crDoc: false,
    contractDoc: false,
    companyLogo: false,
  });
  const credentialToggleModal = () => {
    setCredential(!credential);
    if (!credential) return;
    reset();
    clearErrors();
    setSelectedDocument({
      vatDoc: false,
      crDoc: false,
      contractDoc: false,
      companyLogo: false,
    });
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id]);

  const Section = ({
    title,
    children,
  }: {
    title?: string;
    children: React.ReactNode;
  }) => (
    <div className="p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] space-y-2">
      {/* <h2 className="text-[#212121]/70 font-medium text-sm">{title}</h2> */}
      <div className="grid lg:grid-cols-4 grid-cols-2 gap-x-6">{children}</div>
    </div>
  );

  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="text-sm text-[#212121] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4">
      <p className="capitalize ">{label}:</p>
      <p className="font-medium capitalize"> {value}</p>
    </div>
  );

  const { allowed: canUpdateOutSource, isLoading } = usePermission(
    "outSources",
    "update"
  );

  const roles = ["Company Info", "Drivers List"];

  const [activeRole, setActiveRole] = useState<string>(
    () => localStorage.getItem("OutSourceDetailsActiveRole") || "Company Info"
  );
  useEffect(() => {
    localStorage.setItem("OutSourceDetailsActiveRole", activeRole);
  }, [activeRole]);

  const navigate = useNavigate();

  const handleUpdateOutSource = (data: any) => {
    let { contractDoc, crDoc, vatDoc, companyLogo, ...otherData } = data;
    mutate(
      {
        ...otherData,
        ...(selectedDocument?.contractDoc && {
          contractDoc: data?.contractDoc,
        }),
        ...(selectedDocument?.vatDoc && { vatDoc: data?.vatDoc }),
        ...(selectedDocument?.crDoc && { crDoc: data?.crDoc }),
        ...(selectedDocument?.companyLogo && {
          companyLogo: data?.companyLogo,
        }),
        ...(watch("companyLogo") && { companyLogoAvailabel: true }),
        ...(watch("vatDoc") && { vatDocAvailabel: true }),
        ...(watch("crDoc") && { crDocAvailabel: true }),
        ...(watch("contractDoc") && { contractDocAvailabel: true }),
      },
      {
        onSuccess: () => {
          credentialToggleModal();
          reset();
          refetch();
          toast.success("Outsource Update Successfully.");
          navigate("/users?tab=Out+Source");
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <h1 className="text-xl font-medium text-[#212121] tracking-[-0.5px]  ">
                {data?.name || ""}
              </h1>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {activeRole === "Company Info" && (
            <div className="">
              <Section>
                <div className="flex justify-between items-center lg:col-span-4 col-span-2 pb-3">
                  <h3 className="text-[#212121] font-semibold text-lg  ">
                    Customer Details{" "}
                  </h3>
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0 lg:col-span-4 col-span-2">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Customer Details
                  </h3>

                  <TwoCol label="Customer Name" value={data?.name || ""} />
                  <TwoCol label="Customer Id" value={data?.customId || ""} />
                  <TwoCol label="Email" value={data?.email || ""} />
                  <TwoCol label="Country" value={data?.countryName || ""} />
                  <TwoCol label="City" value={data?.cityName || ""} />
                  <TwoCol label="District" value={data?.districtName || ""} />
                  <TwoCol label="Address" value={data?.address || ""} />
                </div>
                {/* <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Other Details
                  </h3>
                  <div className="grid grid-cols-1 mt-2">
                    <TwoCol
                      label="Specializations"
                      value={data?.specialization}
                    />
                    <TwoCol
                      label="Billing Cycle"
                      value={data?.billingCycle?.toLowerCase()}
                    />
                    <TwoCol
                      label="Service Area Coverage"
                      value={data?.serviceAreaCoverage}
                    />
                  </div>
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Primary Contacts info
                  </h3>
                  <div className="grid grid-cols-1 mt-2">
                    <TwoCol label="Name" value={data?.primaryContactName} />
                    <TwoCol label="Number" value={data?.primaryContactNumber} />
                    <TwoCol label="Email" value={data?.primaryEmailAddress} />
                  </div>
                </div>
                <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden mb-4 lg:mb-0">
                  <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                    Documents Info
                  </h3>

                  <TwoCol
                    label="Contract Date"
                    value={
                      <DocumentLink
                        value={formatDate(data?.contractStartDate)}
                        docUrl={data?.contractDoc}
                        label="Contract Date"
                      />
                    }
                  />
                  <TwoCol
                    label="Tax/VAT"
                    value={
                      <DocumentLink
                        value={data?.vatNumber}
                        docUrl={data?.vatDoc}
                        label="Vat"
                      />
                    }
                  />
                  <TwoCol
                    label="Cr Number"
                    value={
                      <DocumentLink
                        value={data?.crNumber}
                        docUrl={data?.crDoc}
                        label="CR Doc"
                      />
                    }
                  />
                </div> */}
              </Section>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
